<template>
  <li>
    <div
      v-if="status=='init'"
      class="stop flex loading"
    >
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <a
    v-else-if="monitoringTargetStatus==='not_ready'"
    class="stop flex"
    @click="details"
    >
      <div class="main-info flex-t">
        <div class="thumb-round thumb-device">
          <img
            v-if="monitoringTarget.getImageFileUrl() !== ''"
            alt="デバイスのサムネイル"
            :src="monitoringTarget.getImageFileUrl()"
          />
        </div>
        <div class="main-txt">
          <div class="ico-txt">未登録</div>
          <div class="stopped-monitoring-target">
            {{ monitoringTarget.name }}
            <span class="sub-txt">{{ monitoringTarget.monitoringTargetId }}</span>
          </div>
        </div>
      </div>
      <div class="device-msg">
        <div class="msg-bar">まだ登録が完了していません</div>
      </div>
      <div class="device-status flex-r-item">
        <div class="antenna">
          <img src="@/assets/img/ico_antenna_03.png" alt="アンテナアイコン" class="ico-bace ico-l">－
        </div>
        <div class="battery">
          <img src="@/assets/img/ico_battery_03.png" alt="バッテリーアイコン" class="ico-bace ico-l">－
        </div>
      </div>
    </a>
    <a
      v-else-if="monitoringTargetStatus==='not_monitored'"
      class="flex stop"
      @click="details"
    >
      <div class="main-info flex-t">
        <div class="thumb-round thumb-device">
          <img
            v-if="monitoringTarget.getImageFileUrl() !== ''"
            alt="デバイスのサムネイル"
            :src="monitoringTarget.getImageFileUrl()"
          />
        </div>
        <div class="main-txt">
          <div class="ico-txt">停止中</div>
          <div class="active-monitoring-target">
            {{ monitoringTarget.name }}
            <span class="sub-txt">{{ monitoringTarget.monitoringTargetId }}</span>
          </div>
        </div>
      </div>
      <div class="device-msg">
        <div class="msg-bar">設備の監視を停止しました</div>
      </div>

      <div
        class="device-status flex-r-item"
      >
        <div class="antenna">
          <img v-if="this.networkStatus === 'excellent'"
            src="@/assets/img/ico_antenna_03.png" alt="バッテリーアイコン" class="ico-bace ico-l" />
          <img v-else-if="this.networkStatus === 'good'"
            src="@/assets/img/ico_antenna_02.png" alt="バッテリーアイコン" class="ico-bace ico-l" />
          <img v-else-if="this.networkStatus === 'not_good'"
            src="@/assets/img/ico_antenna_01.png" alt="バッテリーアイコン" class="ico-bace ico-l" />
          <img v-else
            src="@/assets/img/ico_antenna_03.png" alt="バッテリーアイコン" class="ico-bace ico-l" />
          <span>{{ this.networkStatusLabel }}</span>
        </div>
        <div class="battery">
          <img v-if="this.batteryStatus === 'high'"
            src="@/assets/img/ico_battery_03.png" alt="バッテリーアイコン" class="ico-bace ico-l" />
          <img v-else-if="this.batteryStatus === 'mid'"
            src="@/assets/img/ico_battery_02.png" alt="バッテリーアイコン" class="ico-bace ico-l" />
          <img v-else-if="this.batteryStatus === 'low'"
            src="@/assets/img/ico_battery_01.png" alt="バッテリーアイコン" class="ico-bace ico-l" />
          <img v-else
            src="@/assets/img/ico_battery_03.png" alt="バッテリーアイコン" class="ico-bace ico-l" />
          <span>{{ this.batteryStatusLabel }}</span>
        </div>
      </div>
    </a>
    <a
      v-else-if="monitoringTargetStatus==='warning'"
      class="flex warning"
      @click="details"
    >
      <div class="main-info flex-t">
        <div class="thumb-round thumb-device">
          <img
            v-if="monitoringTarget.getImageFileUrl() !== ''"
            alt="デバイスのサムネイル"
            :src="monitoringTarget.getImageFileUrl()"
          />
        </div>
        <div class="main-txt">
          <div class="ico-txt">アラート発生中</div>
          <div class="active-monitoring-target">
            {{ monitoringTarget.name }}
            <span class="sub-txt">{{ monitoringTarget.monitoringTargetId }}</span>
          </div>
        </div>
      </div>
      <div class="device-msg">
        <div class="msg-bar">
          {{ notificationTitle }}
        </div>
        <span class="date">
          {{ notificationTimestamp }}
        </span>
      </div>
      <div
        class="device-status flex-r-item"
      >
        <div class="antenna">
          <img v-if="this.networkStatus === 'excellent'"
            src="@/assets/img/ico_antenna_03.png" alt="バッテリーアイコン" class="ico-bace ico-l" />
          <img v-else-if="this.networkStatus === 'good'"
            src="@/assets/img/ico_antenna_02.png" alt="バッテリーアイコン" class="ico-bace ico-l" />
          <img v-else-if="this.networkStatus === 'not_good'"
            src="@/assets/img/ico_antenna_01.png" alt="バッテリーアイコン" class="ico-bace ico-l" />
          <img v-else
            src="@/assets/img/ico_antenna_03.png" alt="バッテリーアイコン" class="ico-bace ico-l" />
          <span>{{ this.networkStatusLabel }}</span>
        </div>
        <div class="battery">
          <img v-if="this.batteryStatus === 'high'"
            src="@/assets/img/ico_battery_03.png" alt="バッテリーアイコン" class="ico-bace ico-l" />
          <img v-else-if="this.batteryStatus === 'mid'"
            src="@/assets/img/ico_battery_02.png" alt="バッテリーアイコン" class="ico-bace ico-l" />
          <img v-else-if="this.batteryStatus === 'low'"
            src="@/assets/img/ico_battery_01.png" alt="バッテリーアイコン" class="ico-bace ico-l" />
          <img v-else
            src="@/assets/img/ico_battery_03.png" alt="バッテリーアイコン" class="ico-bace ico-l" />
          <span>{{ this.batteryStatusLabel }}</span>
        </div>
      </div>
    </a>
    <a
      v-else-if="monitoringTargetStatus==='caution'"
      class="flex caution"
      @click="details"
    >
      <div class="main-info flex-t">
        <div class="thumb-round thumb-device">
          <img
            v-if="monitoringTarget.getImageFileUrl() !== ''"
            alt="デバイスのサムネイル"
            :src="monitoringTarget.getImageFileUrl()"
          />
        </div>
        <div class="main-txt">
          <div class="ico-txt">監視中</div>
          <div class="active-monitoring-target">
            {{ monitoringTarget.name }}
            <span class="sub-txt">{{ monitoringTarget.monitoringTargetId }}</span>
          </div>
        </div>
      </div>
      <div class="device-msg">
        <div class="msg-bar">
          {{ notificationTitle }}
        </div>
        <span class="date">
          {{ notificationTimestamp }}
        </span>
      </div>
      <div
        class="device-status flex-r-item"
      >
        <div class="antenna">
          <img v-if="this.networkStatus === 'excellent'"
            src="@/assets/img/ico_antenna_03.png" alt="バッテリーアイコン" class="ico-bace ico-l" />
          <img v-else-if="this.networkStatus === 'good'"
            src="@/assets/img/ico_antenna_02.png" alt="バッテリーアイコン" class="ico-bace ico-l" />
          <img v-else-if="this.networkStatus === 'not_good'"
            src="@/assets/img/ico_antenna_01.png" alt="バッテリーアイコン" class="ico-bace ico-l" />
          <img v-else
            src="@/assets/img/ico_antenna_03.png" alt="バッテリーアイコン" class="ico-bace ico-l" />
          <span>{{ this.networkStatusLabel }}</span>
        </div>
        <div class="battery">
          <img v-if="this.batteryStatus === 'high'"
            src="@/assets/img/ico_battery_03.png" alt="バッテリーアイコン" class="ico-bace ico-l" />
          <img v-else-if="this.batteryStatus === 'mid'"
            src="@/assets/img/ico_battery_02.png" alt="バッテリーアイコン" class="ico-bace ico-l" />
          <img v-else-if="this.batteryStatus === 'low'"
            src="@/assets/img/ico_battery_01.png" alt="バッテリーアイコン" class="ico-bace ico-l" />
          <img v-else
            src="@/assets/img/ico_battery_03.png" alt="バッテリーアイコン" class="ico-bace ico-l" />
          <span>{{ this.batteryStatusLabel }}</span>
        </div>
      </div>
    </a>
    <a
      v-else
      class="flex"
      @click="details"
    >
      <div class="main-info flex-t">
        <div class="thumb-round thumb-device">
          <img
            v-if="monitoringTarget.getImageFileUrl() !== ''"
            alt="デバイスのサムネイル"
            :src="monitoringTarget.getImageFileUrl()"
          />
        </div>
        <div class="main-txt">
          <div class="ico-txt monitoring">監視中</div>
          <div class="active-monitoring-target">
            {{ monitoringTarget.name }}
            <span class="sub-txt">{{ monitoringTarget.monitoringTargetId }}</span>
          </div>
        </div>
      </div>
      <div
        class="device-status flex-r-item"
      >
        <div class="antenna">
          <img v-if="this.networkStatus === 'excellent'"
            src="@/assets/img/ico_antenna_03.png" alt="バッテリーアイコン" class="ico-bace ico-l" />
          <img v-else-if="this.networkStatus === 'good'"
            src="@/assets/img/ico_antenna_02.png" alt="バッテリーアイコン" class="ico-bace ico-l" />
          <img v-else-if="this.networkStatus === 'not_good'"
            src="@/assets/img/ico_antenna_01.png" alt="バッテリーアイコン" class="ico-bace ico-l" />
          <img v-else
            src="@/assets/img/ico_antenna_03.png" alt="バッテリーアイコン" class="ico-bace ico-l" />
          <span>{{ this.networkStatusLabel }}</span>
        </div>
        <div class="battery">
          <img v-if="this.batteryStatus === 'high'"
            src="@/assets/img/ico_battery_03.png" alt="バッテリーアイコン" class="ico-bace ico-l" />
          <img v-else-if="this.batteryStatus === 'mid'"
            src="@/assets/img/ico_battery_02.png" alt="バッテリーアイコン" class="ico-bace ico-l" />
          <img v-else-if="this.batteryStatus === 'low'"
            src="@/assets/img/ico_battery_01.png" alt="バッテリーアイコン" class="ico-bace ico-l" />
          <img v-else
            src="@/assets/img/ico_battery_03.png" alt="バッテリーアイコン" class="ico-bace ico-l" />
          <span>{{ this.batteryStatusLabel }}</span>
        </div>
      </div>
    </a>
  </li>
</template>

<style scoped lang="css">
.stopped-monitoring-target {
  color:#A8A8A8;
}
.active-monitoring-target {
  color:#333;
}
</style>

<script>
import moment from "moment";
// リソース
import {
  BatteryEmptyIcon,
  BatteryIcon,
  SettingIcon,
} from "icons";
import { SampleImage6 } from "img";
import { RepositoryFactory } from "repositories/factory";

const AscmuMonitoringSettingsRepository = RepositoryFactory.get("ascmu-monitoring-settings");
const MabeeemlMonitoringDevicesRepository = RepositoryFactory.get("mabeeeml-monitoring-devices");

export default {
  name: "MonitoringTargetsListItem",
  props: {
    item: {
      type: Object,
    },
    default: {},
  },
  components: {
  },
  data() {
    return {
      icons: {
        BatteryEmptyIcon,
        BatteryIcon,
        SettingIcon,
      },
      img: {
        SampleImage6,
      },
      monitoringTargetStatus: null,
      monitoringTarget: null,
      ascmuMonitoringSetting: null,
      batteryStatus: null,
      batteryStatusLabel: "-",
      batteryStatusIcon: null,
      networkStatus: null,
      networkStatusLabel: "-",
      networkStatusIcon: null,
      deviceStatus: null,
      status: "init",
      notificationTitle: null,
      notificationTimestamp: null,
      latestLogTimestamp: null,
    };
  },
  async created() {
    this.monitoringTarget = this.item.monitoringTarget;
    const ascmuMonitoringSettings = await AscmuMonitoringSettingsRepository.index(
      this.item.monitoringTarget.monitoringTargetId,
    );
    if (ascmuMonitoringSettings.length > 0) {
      [this.ascmuMonitoringSetting] = ascmuMonitoringSettings;

      // 監視デバイスの状態を取得
      const monitoringDeviceStatus = await MabeeemlMonitoringDevicesRepository.getStatus(
        this.ascmuMonitoringSetting.projectId,
        this.ascmuMonitoringSetting.monitoringDeviceId,
      );

      this.batteryStatus = monitoringDeviceStatus.batteryStatus;
      this.batteryStatusLabel = monitoringDeviceStatus.batteryStatusLabel;
      this.batteryStatusIcon = "ico_battery_03.png";
      if (this.batteryStatus === "high") {
        this.batteryStatusIcon = "ico_battery_03.png";
      } else if (this.batteryStatus === "mid") {
        this.batteryStatusIcon = "ico_battery_02.png";
      } else if (this.batteryStatus === "low") {
        this.batteryStatusIcon = "ico_battery_01.png";
      }
      if (this.batteryStatus === "unknown") {
        this.batteryStatusLabel = "-";
      }

      this.networkStatus = monitoringDeviceStatus.networkStatus;
      this.networkStatusLabel = monitoringDeviceStatus.networkStatusLabel;
      this.networkStatusIcon = "ico_battery_03.png";
      if (this.networkStatus === "excellent") {
        this.networkStatusIcon = "ico_battery_03.png";
      } else if (this.networkStatus === "good") {
        this.networkStatusIcon = "ico_battery_02.png";
      } else if (this.networkStatus === "not_good") {
        this.networkStatusIcon = "ico_battery_01.png";
      }
      if (this.networkStatus === "unknown") {
        this.networkStatusLabel = "-";
      }

      this.deviceStatus = monitoringDeviceStatus.deviceStatus;
      if (monitoringDeviceStatus.latestLogTimestamp) {
        this.latestLogTimestamp = moment(
          monitoringDeviceStatus.latestLogTimestamp,
        ).format("YYYY/MM/DD HH:mm");
      } else if (moment().diff(moment(this.ascmuMonitoringSetting.createdAt), "hours") < 24) {
        this.deviceStatus = "active";
      }
    }
    // 監視設定なし
    if (!this.ascmuMonitoringSetting) {
      this.monitoringTargetStatus = "not_ready";
    } else if (this.monitoringTarget.monitoringStatusCd === "0") {
      this.monitoringTargetStatus = "not_monitored";
    } else if (
      this.ascmuMonitoringSetting
      && this.ascmuMonitoringSetting.monitoringEventStatus.contactEvent === "start"
    ) {
      this.monitoringTargetStatus = "warning";
      this.notificationTimestamp = moment(
        this.ascmuMonitoringSetting.monitoringEventStatus.timestampMsec,
      ).format("YYYY/MM/DD HH:mm");
      this.notificationTitle = "アラート条件を検知しました。";
      if (this.ascmuMonitoringSetting.monitoringEventStatus.notificationTitle) {
        this.notificationTitle
          = this.ascmuMonitoringSetting.monitoringEventStatus.notificationTitle;
      }
    } else if (this.deviceStatus === "inactive") {
      this.monitoringTargetStatus = "warning";
      this.notificationTitle = "24時間状態が確認できません";
      this.notificationTimestamp = this.latestLogTimestamp;
    } else if (this.batteryStatus === "low") {
      this.monitoringTargetStatus = "caution";
      this.notificationTitle = "電池残量が少なくなっています";
      this.notificationTimestamp = this.latestLogTimestamp;
    } else {
      this.monitoringTargetStatus = "normal";
    }

    // // 監視ステータスの取得
    // if (this.ascmuMonitoringSetting.monitoringEventStatus.monitoringEventId) {
    //   this.notification_timestamp = moment(
    //     this.ascmuMonitoringSetting.monitoringEventStatus.timestampMsec,
    //   ).format("YYYY/MM/DD HH:mm");
    //   if (!this.ascmuMonitoringSetting.monitoringEventStatus.notificationTitle) {
    //     this.ascmuMonitoringSetting.monitoringEventStatus.notificationTitle
    //       = "アラート条件を検知しました。";
    //   }
    // }
    this.status = "ready";
  },
  methods: {
    details() {
      this.$router.push({
        name: "MonitoringTargetsDetail",
        params: {
          id: this.item.monitoringTarget.monitoringTargetId,
        },
      });
    },
  },
};
</script>
